import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";

const fieldNameCPF = [
  { field: "Name", class: "text-left" },
  { field: "Identity", type: 'identity', class: "identity text-left" }
];

export default {
  name: "MerchantUser",
  components: {
    TableList
  },
  data() {
    return {
      idMerchant: null,
      headers: [
        { field: "Merchant.Id", label: "IdMerchant", classHeader: 'text-center', classField: 'text-center'},
        { field: fieldNameCPF, label: "Usuário", classHeader: 'text-left', classField: 'text-left' },
        { field: "Email", label: "E-mail", classHeader: 'text-left', classField: 'text-left' },
        { field: "UserProfile.Name", label: "Perfil", classHeader: 'text-left', classField: 'text-left' },
      ],
      selectedMerchantUser: null,
      pageName: 'Usuários do Cliente',
      permissionIsAuthorize: 'MerchantUser',
      countFilter: 0,
      itemList: [],
      profiles: [],
      filter: {
        Name: null,
        Email: null,
        Identity: null,
        Profile: null
      },
      loadingMerchantUser: false,
      loadingProfiles: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      additionalActions: [
        { name: 'ResendEmail', label: 'Reenviar e-mail', icon: 'fas fa-paper-plane' }
      ]
    };
  },

  mounted() {
    if (this.$route.params.idMerchant !== null && this.$route.params.idMerchant !== undefined) {
      this.idMerchant = this.$route.params.idMerchant;
    }

    this.ListUserProfiles()
    this.ListMerchantUser();
  },

  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListMerchantUser();
    },

    ResetFilter() {
      this.filter = {
        Name: null,
        Email: null,
        Identity: null,
        Profile: null
      };
      this.ListMerchantUser();
    },

    ConfirmResendEmail(merchantUser, index, eventName) {
      this.selectedMerchantUser = merchantUser;
      this.$makeMsgBox(
        `Você tem certeza que deseja enviar um e-mail com instruções de definição de senha para ${merchantUser.Name}?`,
        "Confirmar",
        this.ResendEmail
      );
    },

    ResendEmail() {
      this.selectedMerchantUser.Merchant.Id = this.idMerchant;
      this.loadingResendEmail = true;
      this.$store.dispatch("ResendEmailMerchantUser", this.selectedMerchantUser)
        .then(response => {
          this.$makeToast("E-mail reenviado com sucesso", "success", "Reenviar e-mail");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao reenviar o e-mail", error);
        })
        .finally(() => (this.loadingResendEmail = false));
    },

    GetParamsListMerchantUser(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": this.idMerchant,

        "Object.Name": this.filter.Name,
        "Object.Email": this.filter.Email,
        "Object.Identity": this.filter.Identity,
        "Object.UserProfile.Code": this.filter.Profile
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ListMerchantUser() {
      this.loadingMerchantUser = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });
      const params = this.GetParamsListMerchantUser();
      this.$store.dispatch("ListMerchantUser", { params: params })
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loadingMerchantUser = false));
    },

    ListUserProfiles() {
      this.loadingProfiles = true;
      this.$store.dispatch("ListUserProfile", {"Object.Merchant.Id": this.idMerchant})
        .then(response => {
          this.profiles = response.Objects;
          this.profiles.sort((a, b) => a.Name.localeCompare(b.Name));
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os Perfis de Usuários. Tente novamente.",
            "danger",
            "Erro ao listar os Perfis",
            error
          );
        }).finally(() => (this.loadingProfiles = false));
      }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/MerchantUser/MerchantUser.js